import React, {useState} from 'react';
import { Form } from 'react-final-form';
import { Button } from 'reactstrap';
import formValidation from "@/shared/validation/addprogramuser";
import axios from 'axios';
import { fetchRoles } from "@/shared/apiHelper"
import {unpatchSelect, labelizeNamedData} from '@/shared/helpers'
import {useDispatch, sendFlashMessage} from "@/shared/components/flash"
import ApiErrorMessage from "@/shared/components/ApiErrorMessage"
import ProgramUserFormFields from './ProgramUserFormFields'
import arrayMutators from "final-form-arrays"
import getUnitNumbers from '@/services/program/getUnitNumbers'
import {getPositionLevels} from '@/services/program/position'

let config = {
    roleInput:'checkbox',
    roleField: 'roles',
    isProgram: true,
    unitNumberField: 'unit_number',
    unitNumberOptions: [],
    positionLevelField: 'position_level',
    positionLevelOptions: []
}

const AddProgramUserForm = ({organization, program, toggle, setTrigger}) => {
    const dispatch = useDispatch()
    const [saving, setSaving] = useState(false)
    const [roles, setRoles] = useState(null)
    const [unitNumberOptions, setUnitNumberOptions] = useState(config.unitNumberOptions);
    const [positionLevelOptions, setPositionLevelOptions] = useState(config.positionLevelOptions);

    React.useEffect( () => {
        // console.log(program)
        getRoles(program.organization_id, program.id)
    }, [program])

    const getRoles = ( organizationId, programId ) => {
        setSaving(true)
        fetchRoles( organizationId, programId, true )
        .then( data => {
            if( config.roleInput === 'select')    {
                data = labelizeNamedData(data);
            }
            setRoles(data);
            setSaving(false)
        })
    }

    React.useEffect(() => {
      if (organization?.id && program?.id && program?.uses_units) {
        getUnitNumbers(organization.id, program.id, "assignable=1").then( res => {
          setUnitNumberOptions(labelizeNamedData(res));
        })
      }
    }, [organization, program]);

    React.useEffect(() => {
      if (
        organization?.id &&
        program?.id &&
        (program?.use_budget_cascading > 0 ||
          program?.use_cascading_approvals > 0)
      ) {
        getPositionLevels(organization.id, program.id).then(
          (res) => {
            setPositionLevelOptions(
              labelizeNamedData(res, ["id", "title"])
            );
          }
        );
      }
    }, [organization, program]);
  
    const onSubmit = values => {
        if( config.roleInput === 'select')    {
            values = unpatchSelect(values, [config.roleField])
        }
        console.log(values.unit_number)
        if( typeof values.unit_number === 'object') {
          console.log(config.unitNumberField)
          values = unpatchSelect(values, [config.unitNumberField])
        }
        if(values?.send_invite) {
          delete values["password"]
          delete values["password_confirmation"]
        }
        if( typeof values.position_level === 'object') {
            values = unpatchSelect(values, [config.positionLevelField])
          }
        
        values.country_id = values.country_id?.value ?? values.country_id;
        // console.log(values)
        // return
        setSaving(true)
        axios.post(`/organization/${program.organization_id}/program/${program.id}/user`, values)
        .then( (res) => {
            // console.log(res)
            if(res.status < 300)  {
                toggle()
                setTrigger( Math.floor(Date.now() / 1000) )
                dispatch(sendFlashMessage("User added successfully!", 'alert-success'))
            }
            setSaving(false)
        })
        .catch( error => {
            //console.log(error.response.data);
            dispatch(sendFlashMessage(<ApiErrorMessage errors={error.response.data} />, 'alert-danger', 'top'))
            setSaving(false)
        })
    }

    const validate = async(values) => {
        let exclude_fields = []
        if( values?.send_invite )
        {
          exclude_fields.push('password', 'password_confirmation')
        }
        let v1 = await formValidation(exclude_fields).validateForm(values)
        v1 = v1 ? v1 : {}
        if( values?.send_invite )
        {
          delete v1["password"]
          delete v1["password_confirmation"]
        }
        else 
        {
          if( values.password && values.password !== values.password_confirmation )  {
              v1.password_confirmation = 'Passwords do not match'
          }
        }
        return v1
    }

    if( !roles ) return 'Loading...'

    config = {...config, ...{roles}}

    return (
    <Form
        onSubmit={onSubmit}
        validate={validate}
        // initialValues={{
        //     password:''
        // }}
        mutators={{
            ...arrayMutators
        }}
    >
    {({ handleSubmit, form, submitting, pristine, values }) => {
    // console.log(pristine)
    // console.log(values)
    // console.log(form)
    return (
        <form className="form" onSubmit={handleSubmit}>
            <div className="manager-program-modal__form-head">
                <h4 className="manager-program-modal__form-title">New User Details</h4>
                <p className="manager-program-modal__form-copy">
                    Enter the profile, role, and access information for the new program user.
                </p>
            </div>
            <ProgramUserFormFields config={{...config, ...{
              unitNumberOptions
            }, ...{
             positionLevelOptions
            }}} form={form} submitting={submitting} pristine={pristine} values={values} program={program}/>
            <div className="manager-program-modal__footer-actions">
                <Button type="submit" disabled={saving} className="btn btn-primary" color="#ffffff">
                    Save User
                </Button>
            </div>
        </form>
    )}}
    </Form>
)}

export default AddProgramUserForm;
